﻿$(function () {
    // getHosts();
    getVodColumn();
});

function getHosts() {
    var page = parseInt($('.host-list').attr('page'));

    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/home/contents?id=vod&size=14&page=' + page,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }

            var newlist = '';
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];
                var img = '/static/images/no-avatar.png';
                if (info.thumbnail_urls && info.thumbnail_urls.length > 0 && info.thumbnail_urls[0])
                    img = info.thumbnail_urls[0] + '?w=74&h=74&s=3';
                newlist += '<div class="host-item">\n' +
                    '<a href="' + ROOT + '/host/' + info.id + '" target="_blank" class="host-img">' +
                    '<img src="' + img + '"</a>\n' +
                    '<a href="' + ROOT + '/host/' + info.id + '" target="_blank" class="host-name">' + info.title + '</a>\n' +
                    // '<div class="host-position">' + info.summary + '</div>\n' +
                    '</div>\n';
            }

            $('.host-list').html(newlist);
        },
        error: function (data) {
            console.log(data);
        }
    });
}

function getVodColumn() {
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/home/childcolumn?id=vod',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }

            var newlist = '';
            for (var i = 0; i < data.length; i++) {
                var info = data[i];
                newlist += '<div class="vod-item">\n' +
                    '<div class="vod-item-header s' + i % 7 + '">\n' +
                    '<span class="vod-item-title">' + info.name + '</span>\n' +
                    '<a href="' + ROOT + '/column/' + info.id + '" target="_blank" class="vod-item-title">' + '更多' + '</a>\n' +
                    '</div>\n' +
                    '<div class="vod-child-list" dataid="' + info.id + '">\n' +
                    '</div>\n' +
                    '</div>\n';
            }
            if (data.length % 4 > 0) {
                for (var i = 0; i < 4 - data.length % 4; i++) {
                    newlist += '<div class="vod-item"></div>\n';
                }
            }

            $('.vod-list').html(newlist);

            for (var i = 0; i < $('.vod-child-list').length; i++) {
                var id = $($('.vod-child-list')[i]).attr('dataid');
                getChildContent(id);
            }
        },
        error: function (data) {
            console.log(data);
        }
    });
}

function getChildContent(id) {
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/home/contents?id=' + id + '&page=1&size=2',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }

            var newlist = '';
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];

                newlist += '<div class="vod-child-item">';
                newlist += '<a href="' + info.url + '" class="vod-child-img">';
                if (info.thumbnail_urls[0]) {
                    newlist += '<img src="' + info.thumbnail_urls[0] + '?w=224&h=140&s=3' + '"/>';
                } else {
                    newlist += '<img class="default-img" src="' + 'static/images/default.png' + '" width="224" height="140"/>';
                }
                newlist += '</a>';
                newlist += '<a href="' + info.url + '" class="vod-child-title">' + info.title + '</a>';
                newlist += '</div>';
            }

            $('.vod-child-list[dataid=' + id + ']').html(newlist);
        },
        error: function (data) {
            console.log(data);
        }
    });
}